<script>
import scenetools from '@/tools/babylon/scene'
import geometryTools from '@/tools/babylon/geometry'
import cameraTools from '@/tools/babylon/camera'
import lightingTools from '@/tools/babylon/lighting'
import environmentTools from 'bjs_tool/environment'

import materialTools from '@/tools/babylon/materials'
import configure from '@/tools/configurator/configure'
import init from '@/tools/configurator/init'
import splash from 'Components/splash'
import textureload from 'Components/textureload'
import store from 'Store'
import {Color4} from '@babylonjs/core';

import '@babylonjs/inspector'

// import '@babylonjs/loaders/glTF';

export default {
  name: 'playerBabylon',
  props: {
    sceneuid: String
  },
  components: {
    splash,
    textureload
  },
  data: function () {
    return {
      cameraMoves: false
    }
  },  

  computed: {
    loaded () {
      return this.$store.getters['scenes/getsceneLoaded']
      // return true
    },
    ui () {
      return this.$store.getters['ui/getState']
    },    
    myStyle () {
      const pointer = this.ui.navigatebyannotationonly ? 'none' : 'all'

       return {
        'pointer-events': pointer
      }     
    }
  },
  mounted () {
    let myscene = scenetools.scene
    if (myscene) {
      console.log('DISPOSING SCENE')
      materialTools.clearScenematerials()
      myscene.dispose()
      scenetools.engine.dispose()
      scenetools.clear()
    }
    this.loadScene()
  },
  methods: {
    loadScene () {
      // store.commit('model/setProperty', {property: 'menuVisible', value: false})

      let self = this;
      store.dispatch('scenes/setSceneLoading')
      const currentScene = store.getters['scenes/getCurrentScene']
      scenetools.createScene('player__canvas')
      geometryTools.loadModel(currentScene.scenefile).then(function(scene) {
        
        environmentTools.buildSkybox()
        cameraTools.buildCamera()

        geometryTools.buildGround('ground')
        configure.SetLighting()
        configure.SetEnvironment()
        configure.SetPostProcessing()
        self.initMaterialItems()
        init.initViews(currentScene.view)
        scenetools.runRenderLoop()
        self.initViewer(self)
        if (store.state.ui.inspector) {
          scene.debugLayer.show({overlay: true})
        }
        // scene.clearColor = new Color4(0, 0.7, 1, 0.55);
        console.log('scene', scene)
      })


      // const playerSettings = store.getters['player/getPayload']
      // playerTools.init('player__iframe')
      // playerTools.loadScene(sceneuid, this, this.initViewer, playerSettings, this.modelClickEvent, this.cameraStartEvent, this.cameraStopEvent)
    },
    initViewer: function (scope) {
      scope.initDisplayItems()
      scope.setScene()

      // // open the sidebar
      // store.dispatch('scenes/setSceneLoaded')
      store.dispatch('ui/openDrawer')
      // store.commit('model/setProperty', {property: 'menuVisible', value: true})
    },
    setScene () {
      // configure.SetBackground()
    },    

    initDisplayItems () {
      // scenetools.storeSceneGraph().then(() => {
      //   this.initMaterialItems()
      //   init.initVisibility()
      // }, (error) => {
      //   console.log(error)
      // })
    },
    initMaterialItems () {
      materialTools.setupMaterials(store.state.material.all, environmentTools.hdr)
      init.initMaterials()


    }        
  }  
}
</script>

<template>
  <v-container class="fill-height" fluid>
    <splash v-if="!loaded"/>
    <textureload/>
    <!-- <annotationoverlay v-if="loaded" :cameraMoves="cameraMoves"/> -->
    <!-- <iframe class="player" :class="{'iframe__hidden': !loaded}" id="player__iframe" :style="myStyle"></iframe> -->
    <canvas class="player" :class="{'canvas__hidden': !loaded}" id="player__canvas" :style="myStyle"></canvas>
  </v-container>
</template>

<style lang="scss" scoped>
.fill-height {
  padding:0px;
}

.player {
  width: 100%;
  height: 100%;
  border: 0;
  transition: opacity 2.0s ease;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index:0;

  &.canvas__hidden {
    opacity: 0;
  }
.progress {
  position: absolute;
  background-color: #FFFFFF;
  color: #707070;
  font-size:50px;
  text-align:center;
  display: flex;
  justify-content: center; /* align horizontal */
  align-items: center; /* align vertical */
  z-index: 10;
  width: 100%;
  height: 100%;
}

.spinner {
	position: fixed;
	border-radius: 50%;
	height: 40px;
	width: 40px;
	transform: scale(0);
	background: rgba(255, 255, 255, 0.2);
	opacity: 1;
  animation: spinneranimation 800ms linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
}
@keyframes spinneranimation {
	to {
		transform: scale(1.5);
		opacity: 0;
	}
}  
}

</style>
